import { Resources } from 'constants/resources';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { usePermissions } from 'hooks/usePermissions';
import { ApiClientsAccessField } from 'pages/ApiClients/components/ApiClientsAccessField/ApiClientsAccessField';
import { ApiClientsLastActivityField } from 'pages/ApiClients/components/ApiClientsLastActivityField/ApiClientsLastActivityField';
import { ArrayField, TextField, useShowController } from 'react-admin';
import { Link } from 'react-router-dom';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import {
  ChipField,
  DateTimeField,
  FunctionField,
  SingleFieldList,
} from 'shared/react-admin/Fields';
import { ApiClient } from 'types/embedded/apiClient';

export const ApiClientsShowCommonInfoTable = () => {
  const { hasResourceAccess } = usePermissions();
  const {
    record: { merchant },
  } = useShowController();

  const { createPathWithQuery } = useCreatePathWithQuery();

  const createMerchantsPath = (id?: string) =>
    createPathWithQuery({
      resource: Resources.Merchants,
      id,
      type: 'show',
    });

  return (
    <CardTable tableBodyProps={{ sx: { '& td': { width: '188px' } } }}>
      <TableRowWrapper label="ID">
        <TextField source="originId" />
      </TableRowWrapper>
      <TableRowWrapper label="Название">
        <TextField source="name" />
      </TableRowWrapper>
      <TableRowWrapper label="Алиас">
        <TextField source="alias" />
      </TableRowWrapper>
      <TableRowWrapper headerStyle={{ paddingRight: '8px' }} label="Последняя активность">
        <ApiClientsLastActivityField label="Последняя активность" source="activityUpdatedAt" />
      </TableRowWrapper>
      <TableRowWrapper label="Доступ">
        <ApiClientsAccessField />
      </TableRowWrapper>
      {hasResourceAccess(Resources.Merchants) && (
        <TableRowWrapper label={`Мерчант${merchant ? '' : 'ы'}`}>
          {merchant ? (
            <FunctionField
              render={(record: ApiClient) => (
                <Link to={createMerchantsPath(record?.merchant?.['@id'])}>
                  <ChipField source="merchant.name" sx={{ color: 'primary.main' }} />
                </Link>
              )}
            />
          ) : (
            <ArrayField label="Мерчанты" source="merchants">
              <SingleFieldList sx={{ display: 'flex', gap: '4px' }}>
                <FunctionField
                  render={(v) => (
                    <Link to={createMerchantsPath(v?.['@id'])}>
                      <ChipField source="name" sx={{ color: 'primary.main' }} />
                    </Link>
                  )}
                />
              </SingleFieldList>
            </ArrayField>
          )}
        </TableRowWrapper>
      )}
      <TableRowWrapper label="Дата создания">
        <DateTimeField inline source="createdAt" />
      </TableRowWrapper>
      <TableRowWrapper label="Дата редактир.">
        <DateTimeField inline source="updatedAt" />
      </TableRowWrapper>
    </CardTable>
  );
};
